function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.846 4.04a.438.438 0 010 .666l-3.237 2.902a.57.57 0 01-.744 0 .438.438 0 010-.667l2.34-2.096H4.762c-.29 0-.526-.212-.526-.472s.236-.471.526-.471h8.441l-2.339-2.097a.438.438 0 010-.667.57.57 0 01.744 0l3.237 2.902zm-12.05 7.115h8.441c.29 0 .526.212.526.472s-.236.471-.526.471H2.796l2.339 2.097a.438.438 0 010 .667.57.57 0 01-.744 0L1.154 11.96a.438.438 0 010-.667l3.237-2.901a.57.57 0 01.744 0 .438.438 0 010 .667l-2.34 2.096z",
  fill: "#2D2D2D"
});
function SvgSwitchhorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Switch horizontal.svg";
export { SvgSwitchhorizontal as ReactComponent };